import React from 'react'

export default function WobackCloseSvg(props) {
  return (
    <svg width={props.practice ? "39" :"24"} height={props.practice ? "39" :"24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 7L7 17M7 7L17 17" stroke={props.stoke?props.stoke:"#344054"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
